const NETWORK_TO_CHAIN_ID = {
    mainnet: 1n,
    sepolia: 11155111n,
};
export function getChainIdByNetwork(network) {
    return NETWORK_TO_CHAIN_ID[network];
}
//# sourceMappingURL=network.js.map